module.exports = __webpack_public_path__ + "static/media/NFC.3e62046a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/desktop/NFC.svg
// module id = 111
// module chunks = 0